import React, { useEffect, useState } from 'react'
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { toast } from 'react-toastify';
import { Button } from '@app/components';
import { Modal } from 'react-bootstrap';
import { updateConsolidatedOrderStatus } from '@app/services/order';

const UpdateConsolidatedOrderStatusModal = (props) => {

    const statuses = [{slug: 'pending', name: 'Pending'}, {slug: 'on_hold', name: 'On Hold'}, {slug: 'exclude_forever', name: 'Exclude Forever'}]
    const [orderStatus, setOrderStatus] = useState([]);
    const [isLoading, setLoading] = useState(false);

    useEffect(() => {
        setOrderStatus(statuses.filter(item => item.slug !== props?.payload?.status))
    },[props.show]);

    const updateConsolidatedOrderStatusAPI = async (payload) => {
        try {
            setLoading(true);
            const resp = await updateConsolidatedOrderStatus(payload);
            if(resp.success === true){
                setLoading(false);
                toast.success(resp?.message);
                props.handleClose();
                props.getAllProposeMaterialOrders();
            }else{
                toast.error(resp?.errors[0]?.msg);
                setLoading(false);
            }
        } catch (error: any) {
            setLoading(false);
            toast.error(error?.message || 'Internal Server Error');
        }
    };

    const { handleChange, values, handleSubmit, touched, errors } = useFormik({
        initialValues: {
            student_work_order_id: props?.payload?.id,
            status: '',
        },
        validationSchema: Yup.object({
            status: Yup.string().required('Please select status'),
        }),
        onSubmit: (values) => {
            updateConsolidatedOrderStatusAPI(values);
        },
        enableReinitialize: true,
    });

    return (
    <div>
        <Modal show={props.show} onHide={props.handleClose}>
            <Modal.Header closeButton>
                <Modal.Title>Update Status</Modal.Title>
            </Modal.Header>
            <form onSubmit={handleSubmit}>
                <Modal.Body>
                    <div className='row'>
                        <div className="col-sm-6">
                            <div className="form-group">
                                <dt>Student</dt>
                                <dd>{ props?.payload?.student_name ?? '---' } </dd>
                            </div>
                        </div>
                        <div className="col-sm-6">
                            <div className="form-group">
                                <dt>Franchise</dt>
                                <dd>{ props?.payload?.franchise_name ?? '---' }</dd>
                            </div>
                        </div>
                        <div className="col-sm-6">
                            <div className="form-group">
                                <dt>Subject</dt>
                                <dd>{ props?.payload?.subject_name == 'mix_match' ? 'Mix and Match' : props?.payload?.subject_name }</dd>
                            </div>
                        </div>
                        <div className="col-sm-6">
                            <div className="form-group">
                                <label htmlFor="exampleInputEmail1">Status <span className="required">*</span></label>
                                <select 
                                    className="form-control"
                                    name="status"
                                    onChange={handleChange} 
                                    value={values.status}
                                >
                                    <option value="">--Please select--</option>
                                    {orderStatus.length > 0 && orderStatus.map((obj) => (
                                        <option key={obj.slug} value={obj.slug}>
                                            {obj.name}
                                        </option>
                                    ))}
                                </select>
                                {(touched.status && errors.status) && (
                                    <div className="text-danger">
                                        {errors.status}
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <Button type="submit" isLoading={isLoading} className="btn btn-primary mr-2">Update </Button>
                    <Button className='btn btn-default' onClick={props.handleClose}>Close</Button>
                </Modal.Footer>
            </form>
        </Modal>
    </div>
  )
}

export default UpdateConsolidatedOrderStatusModal;